var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("Radar Chart")]),_c('v-card-text',[_c('chartjs-component-radar-chart',{attrs:{"height":355,"data":_vm.chartjsData.radarChart.data,"options":_vm.chartjsData.radarChart.options}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }